const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M15.25 6a.75.75 0 0 0 0 1.5h4.19l-6.19 6.19-3.116-3.117a1.25 1.25 0 0 0-1.768 0L1.72 17.22a.75.75 0 1 0 1.06 1.06l6.47-6.47 3.116 3.117a1.25 1.25 0 0 0 1.768 0L20.5 8.56v4.189a.75.75 0 0 0 1.5 0V6z"/></svg>';
export {
  a as w
};
